import { render, staticRenderFns } from "./tenantname.vue?vue&type=template&id=911da36a&"
import script from "./tenantname.vue?vue&type=script&lang=js&"
export * from "./tenantname.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports